module.exports = __webpack_public_path__ + "static/media/member-photo-mark-williams.321c2c6e.png";